import * as Sentry from "@sentry/react";
import { createRouter,RouterProvider } from "@tanstack/react-router";
import ReactDOM from "react-dom/client";

import "./style.css";

import { queryClient } from "./queryClient";
import { routeTree } from "./routeTree.gen";

const sentryDsn = import.meta.env.PROD
  ? "https://3caf7b48ee4b9de190dc11c0d9555c72@o4510997535719424.ingest.de.sentry.io/4510997542994000"
  : undefined;
if (sentryDsn) {
  const EXPECTED_ERRORS = [
    "Payment method required",
    "Insufficient balance",
    "Storage limit exceeded",
    "ai_provider_unavailable",
    "insufficient_balance",
  ];

  Sentry.init({
    dsn: sentryDsn,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    environment: import.meta.env.MODE,
    beforeSend(event, hint) {
      const error = hint?.originalException;
      if (error instanceof Error && EXPECTED_ERRORS.some((msg) => error.message.includes(msg))) {
        return null;
      }
      return event;
    },
  });
}

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root");

if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<RouterProvider router={router} />);
}
